/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lekos1Inputs */

const de__field_lekos1 = /** @type {(inputs: _Field_Lekos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LeKos`)
};

/**

* @param {_Field_Lekos1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lekos1 = /** @type {((inputs?: _Field_Lekos1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lekos1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lekos1(inputs)
});
export { _field_lekos1 as "_field_leKos" }